<template>
    <button :id="`virtual-${id}`" :class="['app-content-builder-data-object', { 'is--active': isSelected }]" @click.stop="select()">
        <svg class="element-icon--draggable element-icon" width="1em" height="1em"><use href="/img/icons.svg#icon-draggable"></use></svg>
        <slot></slot>
        <p class="app-content-builder-data-object__title app-vertical-navigation__submenu-item-title">{{ title }}</p>
        <p class="app-content-builder-data-object__details">
            <code class="app-content-builder-data-object__id">{{ name }}</code>
            <span v-if="type" class="app-content-builder-data-object__type"> | {{ type }}</span>
        </p>
        <span v-if="nestedStatus"
            :class="['element-badge', statusClassName]">
            {{ statusLabel }}
        </span>
        <div v-if="hasTemplateSelection" class="input select">
            <label for="new-screen-template"></label>
            <app-select
                key="create-from-template"
                placeholder="Select screen template"
                :choices="screenTemplateChoices"
                @update:modelValue="onScreenTemplateSelect">
            </app-select>
        </div>
    </button>
</template>

<script>
import changeSetMixin from '../mixins/change-set'
import { mapGetters, mapState } from 'vuex'

export default {
    mixins: [changeSetMixin],
    props: {
        id: {
            type: [Number, String]
        },
        name: {
            type: String
        },
        title: {
            type: String
        },
        type: {
            type: String
        }
    },
    data () {
        return {
            isOpen: false
        }
    },
    computed: {
        ...mapState('builder', {
            screenTemplateMode: state => state.screenTemplateMode,
        }),
        ...mapGetters('builder', [
            'screenTemplatesForPage',
        ]),
        hasTemplateSelection () {
            return this.screenTemplateMode && this.$store.state.builder.setTemplateSelectionId === this.id
        },
        screenTemplateChoices () {
            // get screenTemplates for object id
            return this.screenTemplatesForPage(this.id) ?? []
        },
        isSelected () {
            return this.$store.state.builder.selectedId === this.id
        }
    },
    methods: {
        onScreenTemplateSelect (template) {
            let _data = template.data
            this.$store.commit('builder/updateDataObject', { id: this.id, data: _data })
            this.$store.commit('builder/setTemplateSelectionId', null)
            this.$store.commit('builder/setSelectedId', this.id)
        },
        select () {
            this.$store.dispatch('builder/selectObject', this.id)
        }
    }
}
</script>